import { useTheme } from "@emotion/react";
import { useState } from "react";
import { Paper, Box, Typography, LinearProgress, Chip, IconButton, Tooltip } from "@mui/material";
import { OpenInFullOutlined } from "@mui/icons-material";
import LineChartComponent from "../../components/lineComponent";
import ModalChartHistory from "../modalChartHistory";
import useStyles from "./styles";
import dayjs from "dayjs";
const utc = require("dayjs/plugin/utc");
const timezone = require("dayjs/plugin/timezone");
dayjs.extend(utc);
dayjs.extend(timezone);
const timeZone = "America/Sao_Paulo";
const LineChartCard = ({
  // Props para o container
  title = "",
  icon: IconComponent,
  loading = false,
  getColor,
  currentValue,
  chipColor,
  chipLabel,
  showChipStatus = false,
  height = "200px",
  // Props para o LineChartComponent (passadas diretamente)
  data = [],
  maxValuebps,
  minValuebps,
  customTooltip,
  mainLineColor,
  mainColor,
  yOptions = {},
  xOptions = {},
  formatDataArray,
  //Props para zoom do linechart
  handleAplicarZoom = () => {},
  isZoomEnabled = false,
  enableHistoryModal = true,
}) => {
  const [openModalHistory, setOpenModalHistory] = useState(false);
  const theme = useTheme();
  const styles = useStyles(theme);

  // Determinar a cor baseada na função getColor ou usar a padrão
  const determinedColor =
    getColor && currentValue ? getColor(currentValue) : "green";

  return (
    <Paper sx={{ ...styles.lineChartPaper, height: height }}>
      {/* Loading Indicator */}
      {loading && <LinearProgress sx={styles.linearProgress} />}

      {/* Header com Ícone e Título */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box sx={styles.lineChartHeader}>
          {IconComponent && (
            <Box
              sx={{
                ...styles.lineChartIconContainer,
                bgcolor: theme.palette.cardGraphic.graphColor[determinedColor],
              }}
            >
              <IconComponent sx={styles.lineChartIcon} />
            </Box>
          )}

          <Typography sx={styles.lineChartTitle}>{title}</Typography>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {showChipStatus && (
            <Chip
              label={chipLabel}
              sx={{
                ...styles.lineChartChip,
                color: theme.palette.chip.colorText[chipColor],
                borderColor: theme.palette.chip.colorText[chipColor],
                backgroundColor: theme.palette.chip.background[chipColor],
              }}
            />
          )}
          {enableHistoryModal && (
            <Tooltip title="Abrir histórico ampliado">
              <IconButton
                size="small"
                onClick={() => setOpenModalHistory(true)}
                sx={{ color: theme.palette.text.secondary }}
              >
                <OpenInFullOutlined fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      </Box>

      <LineChartComponent
        isZoomEnabled={isZoomEnabled}
        onZoomChange={(range) => {
          // Use .unix() para interpretar o valor como segundos
          const startDate = dayjs.unix(range.start).tz(timeZone);
          const endDate = dayjs.unix(range.end).tz(timeZone);

          handleAplicarZoom(startDate, endDate);
        }}
        data={
          Array.isArray(data)
            ? formatDataArray
              ? formatDataArray(data)
              : data
            : []
        }
        maxValuebps={maxValuebps}
        minValuebps={minValuebps}
        customTooltip={customTooltip}
        mainLineColor={mainLineColor}
        mainColor={mainColor}
        yOptions={yOptions}
        xOptions={xOptions}
      />

      {enableHistoryModal && (
        <ModalChartHistory
          open={openModalHistory}
          onClose={() => setOpenModalHistory(false)}
          title={title}
          icon={IconComponent}
          color={determinedColor}
          initialData={Array.isArray(data) ? (formatDataArray ? formatDataArray(data) : data) : []}
          currentValue={currentValue}
          maxValuebps={maxValuebps}
          minValuebps={minValuebps}
        />
      )}
    </Paper>
  );
};

export default LineChartCard;
{
  /* <Paper
                    sx={{
                      display: "flex",
                      height: "200px",
                      p: 2,
                      borderRadius: 4,
                      flexDirection: "column",
                      gap: 1,
                      position: "relative",
                      overflow: "hidden",
                    }}
                  >
                    {loading?.[item?.key] && (
                      <LinearProgress
                        sx={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          zIndex: 1,
                        }}
                      />
                    )}
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "row",
                        gap: 1,
                      }}
                    >
                      {item?.icon && (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            p: 0.4,
                            borderRadius: 1,
                            bgcolor:
                              theme.palette.cardGraphic.graphColor[
                                item?.getColor
                                  ? item?.getColor(
                                      data?.[item?.key]?.currentValue
                                    )
                                  : "green"
                              ],
                          }}
                        >
                          <item.icon sx={{ fontSize: "22px" }} />
                        </Box>
                      )}

                      <Typography
                        sx={{
                          fontWeight: 500,
                          fontSize: "20px",
                          mb: 0.4,
                          "@media (max-width: 600px)": {
                            fontSize: "16px",
                            mb: 0.1,
                          },
                        }}
                      >
                        {item?.title}
                      </Typography>
                    </Box>
                    <LineChartComponent
                      data={
                        Array.isArray(data?.[item?.key]?.data)
                          ? item?.formatDataArray
                            ? item?.formatDataArray(data?.[item?.key]?.data)
                            : data?.[item?.key]?.data
                          : []
                      }
                      maxValuebps={item?.maxValue}
                      minValuebps={item?.minValue}
                      customTooltip={(props) => (
                        <CustomTooltip
                          {...props}
                          valueUnit={item?.valueUnit}
                          title={item?.title}
                          formatValue={item?.formatValue}
                          color={
                            item?.getColor
                              ? item?.getColor(data?.[item?.key]?.currentValue)
                              : "green"
                          }
                        />
                      )}
                      mainLineColor={
                        theme.palette.cardGraphic.graphLineColor[
                          item?.getColor
                            ? item?.getColor(data?.[item?.key]?.currentValue)
                            : "green"
                        ]
                      }
                      mainColor={
                        theme.palette.cardGraphic.graphColor[
                          item?.getColor
                            ? item?.getColor(data?.[item?.key]?.currentValue)
                            : "green"
                        ]
                      }
                      yOptions={{
                        tickFormatter: (value) => {
                          if (item?.formatValue) {
                            return `${item?.formatValue(value)} ${
                              item?.valueUnit || ""
                            }`;
                          }
                          const numericValue = parseFloat(value);
                          if (isNaN(numericValue)) {
                            return `0 ${item?.valueUnit || ""}`;
                          }
                          return `${numericValue.toFixed(1)} ${
                            item?.valueUnit || ""
                          }`;
                        },
                      }}
                    />
                  </Paper> */
}
